export default "__VITE_ASSET__bc48550f__"